import React, { useState, useEffect } from "react";
import { Navbar, Nav, Badge } from 'react-bootstrap';
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import IGSVG from './assets/instagram.svg';
import SecondTeamLogo from './assets/BNF.jpeg';
import Auth from './utils/auth';
import { FaHome, FaBullhorn, FaUsers, FaShoppingCart, FaLock } from "react-icons/fa";
import { ShoppingCart } from "lucide-react";
import { useAuth } from './utils/AuthContext';

function NavTabs({ currentPage, handlePageChange }) {
  const [isTransparent, setIsTransparent] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [formState, setFormState] = useState({});
  const [hovering, setHovering] = useState(false);
  const cartItems = useSelector(state => state.cart);
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);
  const { user } = useAuth();



  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsTransparent(true);
      } else {
        setIsTransparent(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Fetch notification count
  const fetchNotificationCount = async () => {
     if (!user) return;
    const token = Auth.getToken();

    try {
      const res = await fetch(`https://bkf.onrender.com/notifications/${user.userId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

      const data = await res.json();
      const count = (data.notifications || []).length;
      setNotificationCount(count);
    } catch (err) {
      console.error("Failed to fetch notifications:", err);
    }
  };

  // Fetch profile image on mount
  useEffect(() => {
    if (!user) return;

    fetchNotificationCount();

    
    const token = Auth.getToken();

    fetch(`https://bkf.onrender.com/Investors/${user.userId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
      .then(res => {
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        return res.json();
      })
      .then(data => setFormState(data))
      .catch(err => console.error("Error fetching profile image:", err));
  }, [user]);

  // Get logged-in user ID
  // const authUser = Auth.loggedIn();
  // const userId = authUser?.userId;

  const goTo = (path) => {
  setExpanded(false);
  navigate(path);
};

  return (
    <Navbar    
     expanded={expanded}
  onToggle={(val) => setExpanded(val)}
    collapseOnSelect
      expand="md"
      variant="dark"
      fixed="top"
      style={{
        transition: "background 0.3s ease",
        backgroundColor: isTransparent ? "transparent" : "rgba(0,0,0,0.8)",
        boxShadow: isTransparent ? "none" : "0 2px 4px rgba(0,0,0,0.2)"
      }}
    >
      <Nav.Link
         onClick={() => {
              handlePageChange('Home');
              navigate('/');
            }}
        className={currentPage === 'Home' ? 'nav-link active' : 'nav-link'}
        style={{ flex: '0 0 auto' }}
      >
        <img
          src={SecondTeamLogo}
          alt="Second Team Logo"
          style={{ maxWidth: '15vmin', maxHeight: '15vmin', marginRight: '12px',  backgroundColor: 'rgba(0, 0, 0, 0.4)',
     maskImage: `linear-gradient(to right, transparent, white 10%, white 80%, transparent), 
                linear-gradient(to bottom, transparent, white 8%, white 80%, transparent)`,
    WebkitMaskImage: `linear-gradient(to right, transparent, white 2%, white 98%, transparent), 
                      linear-gradient(to bottom, transparent, white 8%, white 98%, transparent)`,
    maskComposite: 'intersect',
    WebkitMaskComposite: 'source-in', }}
        />
      </Nav.Link>

      <Navbar.Toggle aria-controls="responsive-navbar-nav"
      className="ms-auto"
      />
      <Navbar.Collapse id="responsive-navbar-nav"
      className="justify-content-end"
      >
        <Nav className="ms-auto text-md-start text-end align-items-md-center align-items-end">

          <Nav.Link
             onClick={() => {
              handlePageChange('Home');
              navigate('/');
              setExpanded(false);
            }}
            className={currentPage === 'Home' ? 'nav-link active' : 'nav-link'}
            style={{ display: 'flex', alignItems: 'center', color: 'silver' }}
          >
            <FaHome size={24} />
          </Nav.Link>

          {user && (
            <>
              <Nav.Link
                 onClick={() => {
                  handlePageChange('InvestorForum');
                  navigate('/InvestorForum');
                  setExpanded(false);
                }}
                className={currentPage === 'InvestorForum' ? 'nav-link active' : 'nav-link'}
                style={{ display: 'flex', alignItems: 'center', position: 'relative', color: 'silver' }}
              >
                <FaUsers size={24} />
                {notificationCount > 0 && (
                  <Badge
                    bg="danger"
                    pill
                    style={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      transform: "translate(10%, 10%)",
                    }}
                  >
                    {notificationCount}
                  </Badge>
                )}
              </Nav.Link>

              <Nav.Link
                onClick={() => {
                  handlePageChange('Announcements');
                  navigate('/Announcements');
                  setExpanded(false);
                }}
                className={currentPage === 'Announcements' ? 'nav-link active' : 'nav-link'}
                style={{ display: 'flex', alignItems: 'center', color: 'silver' }}
              >
                <FaBullhorn size={24} />
              </Nav.Link>
            </>
          )}

           {/* <Nav.Link
            href="https://brassknucklefilms.myshopify.com/"
     
            style={{ display: 'flex', alignItems: 'center', color: 'silver' }}
          >
            <h3 style={{ margin: 0 }}>Merch</h3>
          </Nav.Link> */}
           <Nav.Link
             onClick={() => {
              handlePageChange('BKFMerchShop');
              navigate('/BKFMerchShop');
              setExpanded(false);
            }}
            className={currentPage === 'BKFMerchShop' ? 'nav-link active' : 'nav-link'}
            style={{ display: 'flex', alignItems: 'center', color: 'silver' }}
          >
            <h3 style={{ margin: 0 }}>Merch</h3>
          </Nav.Link>
          <Nav.Link
             onClick={() => {
              handlePageChange('About');
              navigate('/About');
              setExpanded(false);
            }}
            className={currentPage === 'About' ? 'nav-link active' : 'nav-link'}
            style={{ display: 'flex', alignItems: 'center', color: 'silver' }}
          >
            <h3 style={{ margin: 0 }}>About</h3>
          </Nav.Link>
          

          {user ? (
            <div className="d-flex flex-md-row flex-column align-items-md-center align-items-end"

              >
              {/* Profile Image */}
              <Nav.Link
                onClick={() => {
                  navigate('/InvestorProfile'); 
                  setExpanded(false);
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginLeft: '5px',
                  cursor: 'pointer',
                }}
              >
                {formState.profileI?.length > 0 && (
                  <img
                    src={formState.profileI[0]}
                    alt="Profile"
                    style={{ width: "40px", height: "40px", borderRadius: "50%", objectFit: "cover" }}
                  />
                )}
              </Nav.Link>
                  <Nav.Link
                  onClick={() => {
                  Auth.logout();
                  setExpanded(false);
                }}
                   style={{
                    display: 'flex',
                    alignItems: 'center',
                    color: 'silver',
                    gap: '5px',
                    
                  }}
                >
                  <h5 style={{ margin: 0 }}>Logout</h5>
                  
                </Nav.Link>
            </div>
          ) : (
            <Nav.Link
              href="/Login"
              onClick={() => handlePageChange('Login')}
              className={currentPage === 'Login' ? 'nav-link active' : 'nav-link'}
              style={{ 
                display: 'flex', 
                alignItems: 'center', 
                color: 'silver', 
                gap: '5px' }}
            >
              <FaLock size={20} />
              <h3 style={{ margin: 0 }}>Investors</h3>
            </Nav.Link>
          )}
<Nav.Link
  href="https://www.instagram.com/brassknucklefilms"
  target="_blank"
  rel="noopener noreferrer"
  style={{
    display: 'flex',
    alignItems: 'center',
    color: 'silver',
    gap: '6px',
    marginLeft: '12px',
  }}
>
  <h6 style={{ margin: 0, display: 'inline' }}>Follow Us</h6>
  <img
    src={IGSVG}
    alt="Instagram"
    style={{
      width: '20px',
      height: '20px',
      opacity: 0.9,
    }}
  />
</Nav.Link>


        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default NavTabs;
